<div class="flex flex-col h-full">
    <div class="">
        <div class="border-b border-b-gray-300 zuper-dialog-header" *ngIf="options?.header?.isEnabled !== false">
            <div class="flex justify-between">
                <h6 mat-dialog-title class="font-semibold primary-font">{{(options?.header?.headerDisplayKey ||
                    options.header?.headerDisplayName || 'lineitem.picker.header.text') | translate}}</h6>
            </div>
            <div class="flex items-center ml-auto" *ngIf="options.header.hideCloseIcon !== true">
                <span mat-dialog-close
                    class="rounded-full flex justify-center items-center hover:bg-gray-200 h-9 w-9 p-2 cursor-pointer">
                    <em class="ti ti-x text-xl font-bold"></em>
                </span>
            </div>
        </div>
    </div>
    <!-- Body -->
    <div class="bundle-item-picker-body-container overflow-hidden">
        <div class="flex h-full w-full">
            <!-- Left Panel -->
            <div class="w-1/4 border-r border-r-gray-300 h-full">
                <!-- Bundle Search -->
                <div class="flex h-18 items-center w-full pr-6">
                    <!-- Search Item -->
                    <mat-form-field class="pl-4 pt-4 w-3/4" appearance="fill" *ngIf="options.filters?.search?.enabled">
                        <em class="ti ti-search" matPrefix></em>
                        <input type="text" matInput
                            placeholder="{{'lineitem.picker.item_search.placholder' | translate}}"
                            [(ngModel)]="searchKey" (keyup.enter)="triggerSearch(searchKey)">
                        <em class="ti ti-x close-mark cursor-pointer" *ngIf="searchKey.length"
                            (click)="searchKey='';triggerSearch(searchKey)" matSuffix></em>
                    </mat-form-field>
                
                    <!-- Filter Hide/Show -->
                    <div class="flex items-center justify-evenly ml-3 mt-4 w-1/4">
                        <button mat-stroked-button
                            class="h-11 flex items-center px-4 py-2 border border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none"
                            (click)="changePickerFilterVisibility()">
                            <em class="ti ti-filter text-2xl mr-2"></em>
                            <span>{{(filterVisible ? 'dataPicker.filter.hide': 'text.filters') | translate}}</span>
                        </button>
                    </div>
                </div>
                <div class="px-4 py-1 h-fit" [hidden]="!filterVisible">
                    <!-- Category -->
                    <mat-form-field class="pt-4 w-2/6" appearance="fill"
                        *ngIf="options.filters?.category?.enabled">
                        <mat-select (selectionChange)="onCategoryChange($event)" disableOptionCentering name="category"
                            [panelClass]="['zuper-scrollbar', 'absolute']"
                            placeholder="{{'category.text' | translate}}">
                            <mat-option class="primary-font" [value]="''">
                                <span class="primary-font text-base">{{'lineitem.picker.filter.default_option' |
                                    translate}}</span>
                            </mat-option>
                            <mat-option class="primary-font" *ngFor="let category of categories"
                                [value]="category.category_uid">
                                <span class="primary-font text-base">{{category?.category_name}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <!-- Availability -->
                    <mat-form-field class="pl-4 pt-4 w-2/6" appearance="fill" *ngIf="options.filters?.availability?.enabled">
                        <mat-select (selectionChange)="onAvailabilityChange($event)" disableOptionCentering name="availability"
                            [panelClass]="['zuper-scrollbar', 'absolute']"
                            placeholder="{{'text.availability' | translate}}">
                            <mat-option class="primary-font" [value]="'ALL'">
                                <span class="primary-font text-base">{{'lineitem.picker.filter.default_option' |
                                    translate}}</span>
                            </mat-option>
                            <mat-option class="primary-font" *ngFor="let availability of availabilityTypes" [value]="availability.value">
                                <span class="primary-font text-base">{{availability.displayKey | translate}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <!-- Pricing Level -->
                    <mat-form-field class="pl-4 pt-4 w-2/6" appearance="fill" *ngIf="options.filters?.bundle_pricing_level?.enabled">
                        <mat-select (selectionChange)="onBundlePricingLevelChange($event)" disableOptionCentering name="bundlePricingLevel"
                            [panelClass]="['zuper-scrollbar', 'absolute']"
                            placeholder="{{'text.pricing_options' | translate}}">
                            <mat-option class="primary-font" [value]="'ALL'">
                                <span class="primary-font text-base">{{'lineitem.picker.filter.default_option' |
                                    translate}}</span>
                            </mat-option>
                            <mat-option class="primary-font" *ngFor="let bundlePricing of bundlePricingLevelTypes" [value]="bundlePricing.value">
                                <span class="primary-font text-base">{{bundlePricing.displayKey | translate}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="w-full flex items-center">
                    <p class="text-base md:text-xl font-semibold py-3 px-4 text-gray-600 truncate">
                        {{'text.bundles' | translate}} ({{pagination?.totalRecords ? pagination.totalRecords : options?.data?.length ?? 0 }})
                    </p>
                    <div class="ml-auto flex" *ngIf="!options?.data">
                        <mat-paginator class="ml-auto line-item-paginate" [length]="pagination.totalRecords"
                            [pageSize]="pagination.pageSize" [pageIndex]="pagination.pageIndex - 1" [hidePageSize]="true" 
                            (page)="onPageItemEvent($event)">
                        </mat-paginator>
                    </div>
                </div>                
                <!-- Product Bundle List  -->
                <div class="product-bundles-list overflow-y-auto overflow-x-hidden zuper-scrollbar py-1"
                    [ngClass]="{'filterVisible': filterVisible, 'nonFilterVisible': !filterVisible}">
                    <div class="px-4 space-y-4" *ngIf="!fetchingBundles">
                        <ng-container *ngFor="let product of products; let i = index">
                            <label class="flex items-center w-full py-3.5 px-4 hover:bg-gray-50 border border-gray-300 rounded-md cursor-pointer" for="{{ 'select_bundle_' + i }}" (click)="onSelectProductBundle($event, product)">
                                <input type="radio" class="mt-0.5 h-6 w-6 border-gray-300 text-indigo-600 cursor-pointer" id="{{ 'select_bundle_' + i }}" 
                                [checked]="(product?.line_item_uid && currentSelectedProductBundle?.line_item_uid ? product?.line_item_uid === currentSelectedProductBundle?.line_item_uid : product?.product_uid === currentSelectedProductBundle?.product_uid)">
                                <div class="flex flex-col ml-4 space-y-2 package-select-label-container w-full">
                                    <div class="flex items-center cursor-pointer">
                                        <!-- Image Container -->
                                        <div class="flex-shrink-0 mr-2 w-18">
                                            <img *ngIf="(product?.product_image ?? product?.product_ref_id?.product_image) && utilityService.hasValidProfilePicture((product?.product_image ?? product?.product_ref_id?.product_image))" loading="lazy" 
                                            class="w-14 h-14 rounded border" src="{{ product?.product_image ?? product?.product_ref_id?.product_image }}" alt="{{ product?.name }}">
                                            <img *ngIf="!(product?.product_image ?? product?.product_ref_id?.product_image) && !utilityService.hasValidProfilePicture((product?.product_image ?? product?.product_ref_id?.product_image))" loading="lazy" 
                                            class="w-14 h-14 rounded border" src="assets/images/png/products_image_placeholder.png" alt="{{ product?.name ?? product?.product_ref_id?.product_name }}">
                                        </div>
    
                                        <!-- Product Details -->
                                        <div class="flex-1 space-y-1 w-18">
                                            <p class="font-medium primary-font text-base truncate" [title]="product.product_name ?? product.name">
                                                {{ product.product_name ?? product.name }}
                                            </p>
                                            <p *ngIf="product.product_description || product?.description" class="description-{{ index }} text-secondary w-full sm:w-3/4 md:w-3/4 break-words text-md line-clamp-1 tinymce-text-inner-html"
                                             [ngClass]="{'mb-1': (product.product_description?.length ?? 0) <= 140 || (product.description?.length ?? 0) <= 140}"
                                             [innerHTML]="(product.product_description || product?.description) | safeHtml: false">
                                            </p>
                                        </div>
    
                                        <!-- Price Container -->
                                        <span class="ml-auto font-semibold flex items-center" *ngIf="showPrice">
                                            {{ product?.price | currencyFormat: 'selling-price' }}
                                        </span>
                                    </div>
                                </div>
                            </label>
                        </ng-container>
                    </div>
                    <div *ngIf="fetchingBundles" class="flex justify-center items-center h-full">
                        <lazy-loader></lazy-loader>
                    </div>
                    <div *ngIf="!fetchingBundles && !products?.length && searchKey?.length" class="flex flex-col justify-center h-full">
                        <div class="flex justify-center content-center">
                            <div class="flex flex-col ">
                                <div class="flex justify-center px-2 text-center primary-font break-words">
                                    <h4 class="font-medium mt-4 text-secondary">{{'bundle.picker.not_found.text' | translate}}
                                        '{{searchedValue}}'</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="!fetchingBundles && !products?.length && !searchKey?.length" class="flex flex-col justify-center h-full">
                        <div class="flex justify-center content-center">
                            <div class="flex flex-col">
                                <div class="flex justify-center px-2 text-center primary-font break-words">
                                    <h4 class="font-medium mt-4 text-secondary">{{'bundle.picker.not_found.filer' |  translate}} </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Right Panel -->
            <div class="w-3/4 h-full">
                <app-product-bundle-edit-form [options]="copyOptions" [masterProducts]='products' [selectedBundleDetails]="selectedProductBundle" ></app-product-bundle-edit-form>
            </div>
        </div>
    </div>
    <div class="flex text-right items-center border-gray-300 border-t zuper-dialog-footer" *ngIf="options.footer.isEnabled !== false">
        <button type="button" mat-stroked-button mat-dialog-close
            class="btn-small ml-auto mr-4 primary-font x-6 items-center py-2 border b-1 border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none">
            {{'cancel.text' | translate}}</button>
            <!-- [disabled]="!selectedProducts.length" -->
        <button (click)="addItems($event)" 
            class="flex btn-small primary-font bg-primary px-6 items-center py-2 border b-1 shadow-sm text-white font-medium rounded-md text-white-600 focus:outline-none">
            <mat-spinner [diameter]="18" class="mr-2" *ngIf="AddingBundles"></mat-spinner>
            {{(options.footer?.buttonDisplayKey || options.footer?.buttonDisplayName || 'add.text')
            | translate}}
        </button>
    </div>
</div>